import { WifiOff } from 'lucide-react';
import { useEffect, useState } from 'react';

import { onConnectionChange } from '@/api/client';

/** Global "connection lost" bar: browser offline events or a failed fetch (doc 08 shared behaviours). */
export function ConnectionBar() {
  const [online, setOnline] = useState<boolean>(() => navigator.onLine);
  const [fetchFailed, setFetchFailed] = useState(false);

  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    const unsub = onConnectionChange((ok) => setFetchFailed(!ok));
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
      unsub();
    };
  }, []);

  if (online && !fetchFailed) return null;
  return (
    <div
      role="alert"
      className="mb-3.5 flex items-center gap-2 rounded-lg border border-bad bg-hi-bad px-3 py-2 text-[13px] font-semibold text-bad"
    >
      <WifiOff className="size-4" />
      Connection lost — showing the last data we have. We will retry automatically.
    </div>
  );
}
